import React, { useEffect } from "react";

import { Col, Modal, ModalBody, ModalHeader, Row } from "reactstrap";

// redux toolkit
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { fetchReamingRights } from "../../slices/apps/agreementSlice";

const AgreementReamingModal = ({ id, rowData, isOpen, toggle }) => {
  const dispatch = useDispatch();

  const { reamingRights, reamingRightsLoading } = useSelector((state) => {
    return {
      reamingRights: state.agreement.reamingRights,
      reamingRightsLoading: state.agreement.reamingRightsLoading,
    };
  }, shallowEqual);

  // states

  const fetchData = async () => {
    try {
      const resultAction = await dispatch(fetchReamingRights(id));

      if (resultAction.meta.requestStatus === "fulfilled") {
        setModal(true);
      }
    } catch (error) {
      console.error("Failed:", error);
    }
  };

  // Modal açıldığında veriyi çek
  useEffect(() => {
    if (isOpen && id) {
      fetchData();
    }
  }, [isOpen, id, dispatch]);

  if (reamingRightsLoading) {
    return null;
  }

  return (
    <Modal size="md" isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader
        className="modal-title"
        id="myLargeModalLabel"
        toggle={toggle}
      >
        {rowData?.CustomerName} - Kalan Haklar
      </ModalHeader>

      <ModalBody>
        <div className="mb-4">
          <Row>
            <Col xs={12} className="fw-bold">
              Müşteri:
            </Col>
            <Col xs={12} className="fw-medium">
              {rowData?.CustomerName} | {rowData?.CarPlate}
            </Col>
            <Col xs={12} className="fw-medium">
              {rowData?.CarBrand} {rowData?.CarModel} {rowData?.CarYear}
            </Col>
          </Row>
        </div>

        <ul className="list-group list-group-flush">
          {reamingRights.map((right) => (
            <li
              key={right.value}
              className="list-group-item d-flex justify-content-between align-items-center px-0"
            >
              <span
                className={`fw-medium fs-12 me-3 ${
                  right.count > 0 ? "text-primary" : "text-muted"
                }`}
              >
                {right.label.split(" - ")[0]}
              </span>

              <span
                className={`fw-medium fs-12 text-nowrap flex-shrink-0 ${
                  right.count > 0 ? "text-primary" : "text-muted"
                }`}
              >
                {right.count} Adet
              </span>
            </li>
          ))}
        </ul>
      </ModalBody>
    </Modal>
  );
};

export default AgreementReamingModal;
